import { updateLiquidityCashWithJbItemSettings } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';
import { useLiquiditySettingsMutation } from './use-liquidity-settings-mutation';

export const useUpdateLiquidityCashWithJbItemSettings = () =>
    useLiquiditySettingsMutation({
        mutationFn: (payload) => updateLiquidityCashWithJbItemSettings({ body: payload, path: { id: payload.id! } }).then((result) => result.data!),
        settingsQueryKey: queryKeys.liquidityCashWithJbSettings,
        scope: 'item',
    });
